import type { BuildInfo } from '@rollcall/contracts'
import { useT } from './i18n-context.js'
import { LICENCE_URL, SRD_NOTICE, SRD_URL, versionLabel } from '../version-footer.js'

/**
 * Экран «О приложении»: версия сборки и указание источника SRD.
 *
 * Раньше и то, и другое висело поверх листа неподвижной строкой:
 * на телефоне она накрывала содержимое — карточку атаки, кнопку
 * повышения уровня, — и убрать её было нечем.
 *
 * Условие лицензии (D7, `ATTRIBUTION.md`) от переезда не нарушено:
 * CC BY 4.0 требует, чтобы указание источника было доступно, а не
 * чтобы оно висело поверх текста. Ссылка на этот экран стоит в шапке
 * каждого экрана, а текст приводится здесь целиком и дословно —
 * переводить юридическую формулировку нельзя.
 */

export function AboutScreen({
  build,
  onBack,
}: {
  readonly build: BuildInfo
  readonly onBack: () => void
}) {
  const t = useT()

  return (
    <section className="app-screen" aria-labelledby="about-title">
      <h2 id="about-title">{t('about.title')}</h2>

      <p className="app-about-version" data-testid="about-version">
        {versionLabel(t, build)}
      </p>

      <section aria-labelledby="about-srd">
        <h3 id="about-srd">{t('about.srdTitle')}</h3>
        <p>{t('about.srd')}</p>
        <p lang="en" className="app-about-notice">
          {SRD_NOTICE}
        </p>
        <ul className="app-list">
          <li>
            <a href={SRD_URL} rel="license noreferrer" target="_blank">
              SRD 5.2
            </a>
          </li>
          <li>
            <a href={LICENCE_URL} rel="license noreferrer" target="_blank">
              CC BY 4.0
            </a>
          </li>
        </ul>
      </section>

      <div className="app-actions">
        <button type="button" className="app-button app-button-quiet" onClick={onBack}>
          {t('about.back')}
        </button>
      </div>
    </section>
  )
}
